"use strict";
import Account from "../api/account";
export function getCustomerNameDisplay(customerName, externalId) {
  return [
    customerName,
    Account.currentSettings().customer_display_requires_external_id && externalId ? `(${externalId})` : null
  ].filter(_.identity).join(" ");
}
